<template>
  <div ref="targetEl" :style="`min-height:${fixedMinHeight ? fixedMinHeight : minHeight}px`">
    <slot v-if="shouldRender" />
  </div>
</template>

<script>
export default {
  props: {
    renderOnIdle: Boolean,
    unrender: Boolean,
    minHeight: Number,
    unrenderDelay: {
      type: Number,
      default: 10000,
    },
  },
  data() {
    return {
      shouldRender: false,
      targetEl: null,
      fixedMinHeight: 0,
      unrenderTimer: null,
      renderTimer: null,
    };
  },
  mounted() {
    const options = {
      rootMargin: "600px",
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        clearTimeout(this.unrenderTimer);
        this.renderTimer = setTimeout(() => {
          this.shouldRender = true;
        }, this.unrender ? 200 : 0);
        if (!this.unrender) {
          observer.disconnect();
        }
      } else if (this.unrender) {
        clearTimeout(this.renderTimer);
        this.unrenderTimer = setTimeout(() => {
          this.fixedMinHeight = this.minHeight || this.targetEl.clientHeight;
          this.shouldRender = false;
        }, this.unrenderDelay);
      }
    }, options);

    this.targetEl = this.$refs.targetEl;
    observer.observe(this.targetEl);

    if (this.renderOnIdle) {
      this.onIdle(() => {
        this.shouldRender = true;
        if (!this.unrender) {
          observer.disconnect();
        }
      });
    }
  },
  methods: {
    onIdle(cb = () => {}) {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(cb);
      } else {
        setTimeout(() => {
          this.$nextTick(cb);
        }, 300);
      }
    },
  },
};
</script>